import NavigationCategories from "components/Navigation/NavigationCategories"
import React, { Component, Fragment } from "react"
import FilterContainer from "components/Filter/FilterContainer"
// import {Link, IndexLink} from 'react-router-dom'
import { Header, Table } from "semantic-ui-react"
import shop from "shop/shop"
import app from "app.controller"
import { observer } from "mobx-react"
import categoryStore from "stores/categoryStore"
import "components/Navigation/NavigationSidebar.scss"
import productStore from "stores/productStore"
import { Button, Container, Dropdown, Icon, Image, Menu, Modal } from "semantic-ui-react"
import { Link, NavLink }                                         from "react-router-dom"
import Responsive from "react-responsive"
import MediaQuery from "react-responsive"
import { SearchForm }              from "components/Search/SearchBarWithTypeahead"
import CartButton                                                from "components/Cart/CartButton"
import searchStore                 from "stores/searchStore"
import settingStore from "stores/settingStore"
import languageStore               from "stores/languageStore"

@observer
export default class NavigationSidebar extends Component {
	constructor(props) {
		super(props)
		this.state = {
			categoryData: [],
			isClosed: true
		}
	}

	componentDidMount() {
		shop.events.loaded.add(this.onLoad)
	}

	onLoad = () => {
		this.setState({
			categoryData: shop.categories,
			isClosed: false
		})
	}

	componentWillUnmount() {
		shop.events.loaded.remove(this.onLoad)
	}

	close = () => {
		app.sidebarLeft.close.dispatch()
		this.setState({ isClosed: true })
	}

	render() {
		// const { hasFilter } = categoryStore
		const {showTitle = true} = this.props
		let categoryData         = categoryStore.categories
		const {currentCategory}  = productStore
		const {categoryId}       = currentCategory
		const category           = categoryStore.categoriesById.get(categoryId)
		const {hash} = categoryStore
		const { currentLanguage } = languageStore
		
		if(this.state.isClosed) {
			return null

		}
		return (
			<Fragment>
				<MediaQuery minWidth={768}>
									<nav className="nav NavigationSidebar nav-sidebar overflow-y-auto overflow-x-auto" style={{backgroundColor: "transparent"}}>
				<FilterContainer category={category} query={this.props.query}/>
				<div className="pb2 limited-height NavigationMenuVertical" style={{backgroundColor: "transparent"}}>
					{showTitle && <Header as="h3">{translate("Kategorien")}</Header>}
					<NavigationCategories key={hash} categories={categoryData} />

				</div>
			</nav>
					</MediaQuery>
				<MediaQuery maxWidth={767}>
				<nav className="nav NavigationSidebar nav-sidebar pb4 h-100 overflow-y-auto overflow-x-auto" style={{backgroundColor: "transparent"}}>
				<FilterContainer category={category} query={this.props.query}/>
				<div className="mb6  NavigationMenuVertical">
					{showTitle && <Header as="h3">{translate("Kategorien")}</Header>}

					<NavigationCategories key={hash} categories={categoryData} />
					<div className="pa3 " style={{ alignItems: "center", justifyContent: "center"}}>

					{((!shop.session) || (shop.session && shop.session.shopuser && shop.session.shopuser.guest)) && 
					<Button style={{width: "100%", height: "50px", borderRadius: "35px"}} as={Link} to={`/login/?referrer=${document.location.pathname}`} primary><p className="pt1">{translate( "Bestandskunden: Anmelden" )} </p></Button>}
					{shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&
					<Button style={{width: "100%", height: "50px", borderRadius: "35px"}} as={Link} to={`/logout/?referrer=${document.location.pathname}`} primary><p className="pt1">{translate( "Abmelden" )}</p></Button>}
					<table className="w-100 pa3 pl3">
						<colgroup>
							<col width="50%"/>
							<col width="50%"/>
						</colgroup>
						<tbody>
						<tr>
							<td className="tc pt3 pr3">
								{shop.session && shop.session.shopuser && !shop.session.shopuser.guest && 
								<Button style={{maxWidth: "220px", height: "50px", borderRadius: "35px"}} onClick={app.sidebarLeft.close.dispatch} primary inverted={false} as={Link} to={"/account"}>
								<Icon className="pt2 user circle"></Icon></Button>}
								{((!shop.session) || (shop.session && shop.session.shopuser && shop.session.shopuser.guest)) &&
								<Button style={{maxWidth: "220px", height: "50px", borderRadius: "35px"}} onClick={app.sidebarLeft.close.dispatch} primary inverted={false} as={Link} to={"/login"}>
								<Icon className="pt2 user circle"></Icon></Button>}
							</td>
							<td className="tc pt3 pl3">
								<Button style={{maxWidth: "220px", height: "50px", borderRadius: "35px"}} onClick={app.sidebarLeft.close.dispatch} primary inverted={false} as={Link} to={"/search/"}>
								<Icon className="pt2 search"></Icon></Button>
							</td>
						</tr>
						{shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <tr>
							<td className="tc pt3 pr3">
								<Button style={{maxWidth: "220px", height: "50px", borderRadius: "35px"}} onClick={app.sidebarLeft.close.dispatch} primary inverted={false} as={Link} to={"/orderlist"}>
								<Icon className="pt2 heart"></Icon></Button>
							</td>
							<td className="tc pt3 pl3">
								<Button style={{maxWidth: "220px", height: "50px", borderRadius: "35px"}} onClick={app.sidebarLeft.close.dispatch} primary inverted={false} as={Link} to={"/quickorder"}>
								<Icon className="pt2 shopping basket"></Icon></Button>
							</td>
						</tr>}
						{<tr>
							<td className="tc pt3 pr3" >
								<Button style={{maxWidth: "220px", height: "50px", borderRadius: "35px", display: "flex", alignItems: "center", justifyContent: "center"}} onClick={app.sidebarLeft.close.dispatch} primary inverted={false} as={Link} to={"/cms/sortiment"}>
									<span style={{margin: 0, width: "100%", textAlign: "center"}}>{translate("Sortiment")}</span>
								</Button>
							</td>
							<td className="tc pt3 pl3">
								<Button style={{maxWidth: "220px", height: "50px", borderRadius: "35px", display: "flex", alignItems: "center", justifyContent: "center"}} onClick={app.sidebarLeft.close.dispatch} primary inverted={false} as={Link} to={"/cms/about"}>
									<p style={{margin: 0, width: "100%", textAlign: "center"}}>{translate("Über uns")}</p>
								</Button>
							</td>
						</tr>}
						{<tr>
						</tr>}
						</tbody>	
					</table>
					<div className="pt3">
						<Button style={{width: "100%", height: "50px", borderRadius: "35px", display: "flex", alignItems: "center", justifyContent: "center"}} onClick={app.sidebarLeft.close.dispatch} primary inverted={false} as={Link} to={"/customer_contact"}>
						<span style={{margin: 0, width: "100%", textAlign: "center"}}>{translate("Kontakt ")}</span>
					</Button>
					</div>
					</div>
						{/*<section className="pa2 f4 fw7" >
						<p>{translate("Sprache wählen")}:</p>
						{languageStore.available.length > 1 && <Dropdown style={{color: "black"}} text={currentLanguage.toUpperCase()}
												pointing
												className="pl3 link item">
						<Dropdown.Menu>
						{languageStore.available.map( locale => <Dropdown.Item className="tc"  style={{minWidth: "60px"}}
							key={locale}
							onClick={() => languageStore.setLanguage( locale )}><p className="tc">{locale.toUpperCase()}</p></Dropdown.Item> )}
						</Dropdown.Menu>
						</Dropdown>}
					</section> */}
				</div>
			</nav>
					</MediaQuery>
			</Fragment>
		)
	}
}



// WEBPACK FOOTER //
// ./src/theme/lucht-test/components/Navigation/NavigationSidebar.js